export default __webpack_public_path__ + "static/media/Bertrand.c78be64f.jpg";